<div class="light">
    <div class="layout-topbar">
        <div class="layout-topbar-logo">
            <img src="assets/layout/images/logo.png" alt="PayNowConnect Logo">
        </div>
    </div>
    <div class="layout-main-container">
        <div class="layout-main card">
            <router-outlet></router-outlet>
        </div>

    </div>
    <div class="layout-footer noPrint">
        <div class="layout-footer__brand">
            <img src="assets/layout/images/logo.png" alt="Footer Logo" height="20" class="layout-footer__logo"/>
        </div>
        <nav class="layout-footer__links" aria-label="Footer links">
            <a href="https://policy.civiteksolutions.com/terms-of-service/" target="_blank" rel="noopener noreferrer">Terms of Service</a>
            <span>|</span>
            <a href="https://policy.civiteksolutions.com/accessibility/" target="_blank" rel="noopener noreferrer">Accessibility</a>
        </nav>
    </div>
</div>
<p-dialog header="You Have Been Idle!" [(visible)]="showDialog" [modal]="true" [closable]="false">
    <div class="grid">
        <div class="col-12">
            <p>
                Your payment session is about to expire due to inactivity in
                <span style="color:red;">{{idleCount}}</span>
                seconds!.</p>
        </div>
    </div>
</p-dialog>